import { queryLatestCoupon, queryUnusedCouponAmount, queryCouponRange } from "../api/coupon"
import http from "../api/_http"
import { get, isEmpty } from "lodash"
import dayjs from "dayjs"
import numeral from "numeral"

const state = {
  showCouponModal: false,
  latestCoupon: {},
  unusedCouponAmount: 0,
  couponCal: [] // 日历数据
}

function respConv(res, dft = '{}') {
  return JSON.parse(get(res, 'data.data.value', dft))
}

function queryCurUser() {
  return http.get(`user/current?_ts=${Date.now()}`)
}

// getters
const getters = {
  couponModalTriggerText(state) {
    const totalMoney = get(state, 'latestCoupon.totalMoney', 0)
    return totalMoney ? `系统赠送 ${numeral(totalMoney).format("0,0")} 元优惠券。点击查看详情！` : null
  }
}

// actions
const actions = {
  updateLatestCoupon({ commit }, payload) {
    return queryLatestCoupon().then(respConv).then(data => {
      commit('save', {
        latestCoupon: {
          ...data,
        }
      })
      return data
    }).catch(err => {
      console.log(err)
    })
  },
  updateUnusedCouponAmount({ commit }, payload) {
    queryCurUser().then(res => {
      if (get(res, 'data.user', false)) {
        return queryUnusedCouponAmount(payload).then(respConv).then((data) => {
          commit('save', {
            unusedCouponAmount: data
          })
          return data
        }).catch(err => {
          commit('save', {
            unusedCouponAmount: 0
          })
        })
      } else {
        commit('save', {
          unusedCouponAmount: 0
        })
      }
    })
    
  },
  queryCouponCal({ commit }, payload) {
    return queryCouponRange(payload).then(respConv).then((data) => {
      let cal = data.map(item => ({
        date: dayjs(item.date).format("YYYY-MM-DD"),
        hasCoupon: item.canUse
      }))
      commit("save", {
        couponCal: cal
      })
    })
  }
}

// mutations
const mutations = {
  toggleCouponModal(state, bool) {
    state.showCouponModal = bool
  },
  showCouponModalIfHasCoupon() {
    // debugger
    if (!isEmpty(state.latestCoupon) && state.latestCoupon) {
      state.showCouponModal = true
    }
  },
  save(state, payload) {
    Object.assign(state, payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/stores/coupon.module.js